import React from "react";
import {motion, useAnimation} from 'framer-motion'
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";


const SocialCard = ({ gitIcon,title,username }) => {
  const animation = useAnimation();
  const { ref, inView } = useInView();
  useEffect(() => {
    if (inView) {
      animation.start({
        y: 0,
        transition: {
          duration: 1,
          delay: .1,
          opacity:1
        }
      })
    }
    else {
      animation.start({
        y: 200,
        transition: {
          duration: 1,
          delay: .1,
          opacity:0
        }
      })
    }
  })
  return (
    <motion.div
      animate={animation}
      ref={ref}
      whileHover={{ scale: 1.2 }}
      transition={{duration:.5}}
    >
      
      <div
        className="bg-black bg-opacity-50 shadow-md shadow-blue-700 border-gray-600 p-5 h-16 lg:h-48 w-16 lg:w-48 rounded-md flex flex-col items-center justify-center space-y-5">
        {gitIcon}
        <p className="hidden lg:block font-bold text-sm lg:text-2xl text-blue-500">{ title}</p>
        <p className="hidden lg:block text-blue-600 text-sm lg:text-md">{ username}</p>
      </div>
    </motion.div>
  );
};

export default SocialCard;
